(() => {
  if (typeof Swiper === "undefined") {
    console.error("Swiper not initialized");
  } else {
    let thumbs = null;

    if (document.querySelector("#product-gallery-thumbs")) {
      thumbs = new Swiper("#product-gallery-thumbs", { slidesPerView: 3, spaceBetween: 16 });
    }

    new Swiper("#product-gallery", {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".next-arrow-svg",
        prevEl: ".prev-arrow-svg"
      },
      thumbs: { swiper: thumbs }
    });
  }

  // Utils
  const formatMoney = (cents, format = "") => {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.themeVariables.settings.moneyFormat;

    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  };

  // CustomHTML
  class TabsWrapper extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.contents = [];

      this.handleTriggerClickBound = this.handleTriggerClick.bind(this);
    }

    handleTriggerClick(e) {
      const currentTarget = e.currentTarget;
      if (!currentTarget || !currentTarget.hasAttribute("data-tab-trigger")) return;
      const activeTriggerId = currentTarget.getAttribute("data-tab-trigger");

      this.contents.forEach((content) => {
        const contentId = content.getAttribute("data-tab-content");
        content.classList.remove("active");
        if (activeTriggerId === contentId) content.classList.add("active");
      });

      this.triggers.forEach((trigger) => {
        const triggerId = trigger.getAttribute("data-tab-trigger");
        trigger.classList.remove("active");
        if (activeTriggerId === triggerId) trigger.classList.add("active");
      });
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll("[data-tab-trigger]"));
      this.contents = Array.from(this.querySelectorAll("[data-tab-content]"));

      if (this.triggers.length !== this.contents.length) {
        console.error("Node mismatch");
        return;
      }

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.handleTriggerClickBound);
      });
    }

    disconnectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener("click", this.handleTriggerClickBound);
      });
    }
  }

  class CustomSelect extends HTMLElement {
    constructor() {
      super();

      // Props
      this.open = false;
      this.name = null;
      this.value = null;

      // Nodes
      this.trigger = null;
      this.content = null;
      this.options = [];
      this.selectedOption = null;

      // Events
      this.handleTriggerClickBound = this.handleTriggerClick.bind(this);
      this.handleBodyClickBound = this.handleBodyClick.bind(this);
      this.handleOptionClickBound = this.handleOptionClick.bind(this);
    }

    get selectedOption() {
      return this._selectedOption;
    }

    set selectedOption(newSelectedOption) {
      if (this.selectedOption) {
        this.selectedOption.classList.remove("selected");
      }

      if (newSelectedOption) {
        newSelectedOption.classList.add("selected");
      }

      this._selectedOption = newSelectedOption;
    }

    set value(newValue) {
      if (!newValue) return;
      const option = this.options.find((opt) => opt.value === newValue);
      if (!option) return;
      this.selectedOption = option;
      this.cloneOptionToTrigger();
      this._value = newValue;
      this.classList.add("has-value");
    }

    get value() {
      return this._value;
    }

    set open(isOpen) {
      this._open = isOpen;
      this.classList.remove("open");
      document.body.removeEventListener("click", this.handleBodyClickBound);
      if (isOpen) {
        this.classList.add("open");
        document.body.addEventListener("click", this.handleBodyClickBound);
      }
    }

    get open() {
      return this._open;
    }

    handleOptionClick(e) {
      const clickedOption = e.currentTarget;
      if (!clickedOption) return;

      this.selectedOption = clickedOption;
      this.value = clickedOption.value;
      this.open = false;
      this.dispatchEvent(
        new CustomEvent("select:option:click", {
          detail: { value: this.value, name: this.name, option: clickedOption },
          bubbles: true
        })
      );
    }

    handleBodyClick(e) {
      if (this.contains(e.target)) return;
      this.open = false;
    }

    handleTriggerClick() {
      this.open = !this.open;
    }

    cloneOptionToTrigger() {
      if (!this.selectedOption) return;
      const container = this.trigger.querySelector(".select-trigger-display");
      container.innerHTML = this.selectedOption.innerHTML;
    }

    connectedCallback() {
      this.trigger = this.querySelector("[data-select-trigger]");
      this.content = this.querySelector("[data-select-content]");
      this.options = Array.from(this.querySelectorAll("[data-select-option]"));
      this.selectedOption = this.options.find((option) => option.classList.contains("selected")) || null;

      this.value = this.selectedOption ? this.selectedOption.value : null;
      this.name = this.getAttribute("data-name");

      if (!this.trigger || !this.content) {
        console.error("Trigger/Content missing !");
        return;
      }

      this.trigger.addEventListener("click", this.handleTriggerClickBound);
      this.options.forEach((option) => {
        option.addEventListener("click", this.handleOptionClickBound);
      });
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener("click", this.handleTriggerClickBound);
      }

      this.options.forEach((option) => {
        option.removeEventListener("click", this.handleOptionClickBound);
      });
      document.body.removeEventListener("click", this.handleBodyClickBound);
    }
  }

  class VariantSelect extends HTMLElement {
    constructor() {
      super();

      // Props
      this.selectedVariant = null;
      this.productJson = null;

      // Nodes
      this.initialized = false;
      this.pills = [];
      this.customSelects = [];
      this.submitButton = null;
      this.variantTitleContainers = [];
      this.variantPriceContainers = [];
      this.ghostVariantInput = null;

      // Events
      this.handlePillChangeBound = this.handlePillChange.bind(this);
      this.handleCustomSelectChangeBound = this.handleCustomSelectChange.bind(this);
    }

    set selectedVariant(variant) {
      this._selectedVariant = variant || null;
      this.updateVariantDisplay();

      if (!this.initialized) return;
      this.dispatchEvent(
        new CustomEvent("select:variant:change", {
          detail: { variant },
          bubbles: true
        })
      );
    }

    get selectedVariant() {
      return this._selectedVariant;
    }

    selectVariantById(variantId) {
      if (!variantId) return;
      const variant = this.productJson.variants.find((variant) => variant.id === variantId);
      if (!variant) return;

      // Update custom selects based on variant options
      variant.options.forEach((optionValue, index) => {
        if (this.customSelects[index]) {
          // Update custom select
          this.customSelects[index].value = optionValue;

          // Update pills
          const optionName = this.customSelects[index].name;
          this.pills.forEach((pill) => {
            if (pill.name === optionName) {
              pill.checked = pill.value === optionValue;
            }
          });
        }
      });

      this.selectedVariant = variant;
    }

    updateVariantDisplay() {
      if (!this.selectedVariant) {
        if (this.submitButton) {
          this.submitButton.disabled = true;
        }

        return;
      }

      this.variantTitleContainers.forEach((container) => {
        container.innerHTML = this.selectedVariant.title;
      });

      this.variantPriceContainers.forEach((container) => {
        container.innerHTML = formatMoney(this.selectedVariant.price);
      });

      if (this.submitButton) {
        this.submitButton.disabled = !this.selectedVariant.available;
      }

      this.ghostVariantInput.value = this.selectedVariant.id;

      this.updateOptionPrices();
    }

    getVariantPriceForOptionValue(optionIndex, optionValue) {
      if (!this.productJson || !this.customSelects || optionIndex < 0 || optionIndex >= this.customSelects.length) {
        return null;
      }

      // Build option values: current selections with one option replaced
      // This represents the variant that would be selected if we chose this option value
      const optionValues = this.customSelects.map((customSelect, index) => {
        return index === optionIndex ? optionValue : customSelect.value || null;
      });

      // If any option is not selected (null), we can't determine the variant price
      if (optionValues.some((value) => value === null)) {
        return null;
      }

      // Find the variant that matches these option values
      const variant = this.productJson.variants.find((variant) =>
        variant.options.every((option, index) => option === optionValues[index])
      );

      return variant ? variant.price : null;
    }

    // Updates all elements with data-option-price attribute based on current selections
    updateOptionPrices() {
      if (!this.productJson || !this.customSelects) return;

      // Get all elements with data-option-price
      const optionPriceElements = Array.from(this.querySelectorAll("[data-option-price]"));

      optionPriceElements.forEach((element) => {
        const optionValue = element.getAttribute("data-option-price");
        if (!optionValue) return;

        // Find which custom-select this option belongs to
        const customSelect = element.closest("custom-select");
        if (!customSelect) return;

        const optionIndex = this.customSelects.indexOf(customSelect);
        if (optionIndex === -1) return;

        // Get the variant price for this option value
        const price = this.getVariantPriceForOptionValue(optionIndex, optionValue);

        // Update the element's text content with the formatted price
        if (price !== null) {
          element.textContent = formatMoney(price);
        }
      });
    }

    handlePillChange(e) {
      const pill = e.currentTarget;
      if (!pill) return;

      // Reflect changes to custom select
      this.customSelects.forEach((customSelect) => {
        if (customSelect.name === pill.name) customSelect.value = pill.value;
      });

      this.selectedVariant = this.getSelectedVariant();
    }

    handleCustomSelectChange(e) {
      const customSelect = e.currentTarget;
      if (!customSelect) return;
      const value = customSelect.value;

      // Reflect changes to pill select
      this.pills.forEach((pill) => {
        if (pill.name === customSelect.name) pill.checked = pill.value === value;
      });

      this.selectedVariant = this.getSelectedVariant();
    }

    getSelectedVariant() {
      if (!this.productJson) return null;
      const selectedValues = this.customSelects.map((customSelect) => customSelect.value);
      return this.productJson.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedValues[index])
      );
    }

    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll(".pills input[type='radio']"));
      this.customSelects = Array.from(this.querySelectorAll("custom-select"));
      this.ghostVariantInput = this.querySelector("form select[name='id']");
      this.submitButton = this.querySelector("form button[type='submit']");
      this.variantTitleContainers = Array.from(this.querySelectorAll("[data-variant-title]"));
      this.variantPriceContainers = Array.from(this.querySelectorAll("[data-variant-price]"));

      if (!this.ghostVariantInput) {
        console.error("Ghost variant input not found");
        return;
      }

      const productJsonScript = document.querySelector(".product-json[type='application/json']");
      if (!productJsonScript) {
        console.error("Product JSON not found");
        return;
      }

      this.productJson = JSON.parse(productJsonScript.textContent);

      if (this.hasAttribute("data-initial-variant-id")) {
        this.selectVariantById(parseInt(this.getAttribute("data-initial-variant-id")));
      }

      this.selectedVariant = this.getSelectedVariant();

      this.pills.forEach((pill) => {
        pill.addEventListener("change", this.handlePillChangeBound);
      });

      this.customSelects.forEach((customSelect) => {
        customSelect.addEventListener("select:option:click", this.handleCustomSelectChangeBound);
      });

      this.classList.remove("loading");
      this.classList.add("initialized");
      this.initialized = true;
    }

    disconnectedCallback() {
      this.pills.forEach((pill) => {
        pill.removeEventListener("change", this.handlePillChangeBound);
      });

      this.customSelects.forEach((customSelect) => {
        customSelect.removeEventListener("select:option:click", this.handleCustomSelectChangeBound);
      });
    }
  }

  class PopUpTrigger extends HTMLElement {
    constructor() {
      super();
      // Props
      this.action = "open";
      this.targetPopup = null;

      // Nodes
      this.popup = null;

      // Events
      this.handleBodyClickBound = this.handleBodyClick.bind(this);
      this.handleClickBound = this.handleClick.bind(this);
    }

    set active(isActive) {
      this.popup.classList.remove("active");
      document.body.classList.remove("popup-open");
      document.body.removeEventListener("click", this.handleBodyClickBound);

      if (isActive) {
        this.popup.classList.add("active");
        document.body.classList.add("popup-open");
        document.body.addEventListener("click", this.handleBodyClickBound);
      }

      this._active = isActive;
    }

    get active() {
      return this._active;
    }

    handleClick() {
      this.active = this.action === "open";
    }

    handleBodyClick(e) {
      if (e.target.classList.contains("option-popup")) {
        this.active = false;
      }
    }

    connectedCallback() {
      this.action = this.getAttribute("data-action") || "open";
      this.targetPopup = this.getAttribute("data-popup");
      this.popup = this.closest(".option-popup");
      if (!this.popup) this.popup = document.querySelector(`.option-popup[data-popup="${this.targetPopup}"]`);

      if (!this.popup) {
        console.error("Pop-up not found");
        return;
      }

      this.addEventListener("click", this.handleClickBound);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickBound);
      document.body.removeEventListener("click", this.handleBodyClickBound);
    }
  }

  customElements.define("custom-select", CustomSelect);
  customElements.define("variant-select", VariantSelect);
  customElements.define("tabs-wrapper", TabsWrapper);
  customElements.define("popup-trigger", PopUpTrigger);
})();
